function Signature() {
  return (
    <div className="text-primary-text flex justify-center mt-20 mb-10">
      <p>
        made by{' '}
        <a
          href="https://twitter.com/josephliow"
          target="_blank"
          className="hover:text-secondary-text"
          rel="noreferrer"
        >
          @josephliow
        </a>
      </p>
    </div>
  );
}

export default Signature;
